import getCurrentThemeBase from './contants';

const getTheme = (themeMode, isContrast, preset) => {
    // if  themeMode is light then base will be  light theme and same for dark mode
    // theme off (means light mode on), isContrast off
    let base = getCurrentThemeBase(themeMode);

    // if you want to add contrast colors logic, add here
    // if (isContrast) {
    //   base = {
    //     ...base,
    //     background: {
    //       // paper: "#FFFFFF",
    //       paper: isContrast ? base.grey[100] : "#ffffff",
    //       default: isContrast ? base.grey[100] : "#ffffff",
    //       // neutral: isContrast ? grey[200] : "#ffffff",
    //     },
    //   };
    // }

    // if you want to add preset colors logic, add here
    // if (preset > 0) {
    //   base = {
    //     ...base,
    //     primary: {
    //       ...base.primary,
    //       main: PRESET_COLORS[preset - 1].main,
    //     },
    //   };
    // }

    return base;
};
export function palette(themeMode, isContrast, preset) {
    return {
        mode: themeMode,
        ...getTheme(themeMode, isContrast, preset),
        contrastThreshold: 3,
    };
}
